import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import * as actions from '../../actions/index';

import './Wheel.css';

const Wheel = props => (
  <section className="wheel">
    <video className="wheel__video" loop autoPlay>
      <source src="./assets/videos/operate-service-wheel.mp4" type="video/mp4" />
    </video>
    <img
      className="wheel__image"
      src="./assets/images/service-wheel.png"
      alt="service wheel"
    />
    <button className="wheel__button a" onClick={() => props.setModal(0)}>
      Explore
    </button>
    <button className="wheel__button b" onClick={() => props.setModal(1)}>
      Explore
    </button>
    <button className="wheel__button c" onClick={() => props.setModal(2)}>
      Explore
    </button>
    <button className="wheel__button d" onClick={() => props.setModal(3)}>
      Explore
    </button>
  </section>

);

Wheel.propTypes = {
  setModal: propTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    setModal: (index) => {
      dispatch(actions.setModal(index));
    },
  };
}

export default connect(null, mapDispatchToProps)(Wheel);



// WEBPACK FOOTER //
// ./src/components/Wheel/Wheel.js